import styled from 'styled-components';

export const Content = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const SearchInput = styled.div`
    width: 100%;
    height: 30px;

    border-radius: 3px;
    background-color: rgba(239, 240, 242, 0.18);

    &:placeholder {
        color: #909fac;
    }
`;

export const TabsContainer = styled.div`
    width: 100%;
    display: flex;
`;

export const ScrollableExercisesContainer = styled.div`
    flex: 1;
    overflow: auto;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar-track {
        background: #000;
    }

    &::-webkit-scrollbar {
        width: 10px;
        background: #000;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        border: 1px solid #333333;
        background: #000;
    }
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/WorkoutPlan/LeftBox/style.js